import BaseService from '@/services/BaseService';
import Vue from 'vue';

class CategoryService extends BaseService {
  static findParents(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get(`${this.resource}/parents/`, { params })
        .then(response => resolve(response.body))
        .catch(err => reject(err));
    });
  }
}

Object.assign(CategoryService, {
  resource: 'categories',
});

export default CategoryService;
